import { useSearch } from '@faststore/sdk'
import Select from 'src/components/ui/Select'
import useWindowDimensions from 'src/components/hooks/useWindowDimensions'
import { useState } from 'react'

const OptionsMap = {
  price_desc: 'Mayor Precio',
  price_asc: 'Menor Precio',
  orders_desc: 'Más Vendidos',
  name_asc: 'A-Z',
  name_desc: 'Z-A',
  release_desc: 'Lanzamiento',
  discount_desc: 'Mejor descuento',
  score_desc: 'Más Valorados',
}

const keys = Object.keys(OptionsMap) as Array<keyof typeof OptionsMap>

function Sort() {
  const { isMobile } = useWindowDimensions()
  const { state, setState } = useSearch()
  const [selectIsOpen, setSelectIsOpen] = useState<boolean>(false)

  return (
    <Select
      id="sort-select"
      className="sort / text__title-mini-alt sortBy__inner-container"
      label={!isMobile ? 'Ordenar por' : ''}
      options={OptionsMap}
      onChange={(e) => {
        const sort = keys[e.target.selectedIndex]

        setState({
          ...state,
          sort,
          page: 0,
        })
        selectIsOpen ? setSelectIsOpen(false) : setSelectIsOpen(true)
      }}
      value={state.sort}
      testId="search-sort"
      arrowClass={selectIsOpen ? `arrow-up` : `arrow-down`}
      selectIsOpen={selectIsOpen}
      setSelectIsOpen={setSelectIsOpen}
    />
  )
}

export default Sort
